/* istanbul ignore file */
import React, { useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  RadioGroup,
  FormControlLabel,
  Radio,
  Typography,
} from '@material-ui/core';
import { get, isNil } from 'lodash';
import DateFnsUtils from '@date-io/date-fns';
import {
  FormControl,
  TextField,
  InputLabel,
  Select,
  MenuItem,
} from '@material-ui/core';
import { CHOICE } from 'containers/PreOpeningPage/constants';
import * as featureService from 'features/fflip-helpers';
import { IntlShape, injectIntl } from 'react-intl';
import frLocale from 'date-fns/locale/fr';
import WarningCard from 'components/InvoiceFeeNoteDialog/WarningCard';
import styled from 'styled-components';
import { translate } from 'containers/services/translate';
import messages from 'containers/RecapPage/messages';
import { CorporealDocument } from 'containers/common/LegalProceedings/JudgementAdd/Forms/JudgementAddPrononcings/typings';
import PrimaryButton from 'components/Buttons/PrimaryButton';
import SecondaryButton from 'components/Buttons/SecondaryButton';
import { DOCUMENT, FEE_NOTE } from 'containers/data-structure';
import UploadDocumentBloc from 'containers/common/LegalProceedings/JudgementAdd/Forms/JudgementAddPrononcings/UploadDocumentBloc';
import { DOC_MESSAGES, DOC_TYPES } from 'containers/LawyerFeeNote/constants';
import { FEATURES } from 'features/features';
import { getDateIgnoreTimezone } from 'containers/common/LegalProceedings/utils';

import { compareDate } from 'containers/CourtManagerLegalProceedings/AssignExpert/utils';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import moment from 'moment';
import {
  DATE_FORMAT,
  DATE_PICKET_FORMAT,
  DOCUMENT_TYPES,
} from 'constants/global';
import { dateStringToLocalDate } from 'containers/IdentificationPage/utils';

const StyledDiv = styled.div`
  width: 576px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .select {
    width: 90%;
    margin-bottom: 33px;
    font-size: 13px;
  }
  .input {
    width: 60%;
    margin-bottom: 33px;
    font-size: 13px;
  }
`;
const StyledDialogActions = styled(DialogActions)`
  position: relative;
  padding: 20px 30px;
  display: flex;
  flex-direction: row;

  .primary-button {
    padding-left: 5px;
    color: #ffffff !important;
    border-color: #0075c9;
    background-color: #0075c9;
    &:hover {
      background-color: #0075c9;
      border: 1px solid #0075c9;
    }
    &:mui-disabled {
      color: #ffffff;
    }
  }
  .Mui-disabled {
    opacity: 0.6;
  }
`;

export interface CostsDialogProps {
  intl: IntlShape;
  open: boolean;
  onClose: Function;
  ConfirmAction: Function;
  handleChangeCosts: Function;
  document: any;
  setDocument: Function;
  resetUploadedDocument: Function;
  cost: any;
  uploadDocument: Function;
  uploadedDocument: any;
  setDocumentId: Function;
  decisionCosts: any;
  setDecisionCosts: Function;
  invoiceAdditionnelFeesDocument: any;
  setInvoiceAdditionnelFeesDocument: Function;
  invoiceNumberAdditionnelFees: any;
  setInvoiceNumberAdditionnelFees: Function;
  invoiceDateAdditionnelFees: any;
  setInvoiceDateAdditionnelFees: Function;
  limitInvoiceDate: any;
  setInvoiceReceptionDateAdditionnelFees: Function;
  invoiceReceptionDateAdditionnelFees: any;
  claimReceptionDate?: any;
  fillReceptionDate: boolean;
}

const CostsDialog: React.FC<CostsDialogProps> = (props): JSX.Element => {
  useEffect(() => {
    if (
      props.fillReceptionDate &&
      props.claimReceptionDate &&
      props.setInvoiceReceptionDateAdditionnelFees
    ) {
      const theDate = getDateIgnoreTimezone(props.claimReceptionDate);
      props.setInvoiceReceptionDateAdditionnelFees(
        moment(theDate as Date).format(DATE_FORMAT),
      );
    }
  }, [props.claimReceptionDate]);

  const handleClose = () => {
    props.onClose();
  };
  const handleChange = (field: string) => (
    event: React.ChangeEvent<{
      value: any;
    }>,
  ) => {
    props.handleChangeCosts({
      ...props.cost,
      [FEE_NOTE.CREATED_AT]: new Date(),
      [field]: event.target.value,
      document: {
        ...props.document,
        ...(field === DOCUMENT.TYPE
          ? { [field]: event.target.value }
          : undefined),
      },
    });
  };
  const handleChangeDecisionCosts = (
    event: React.ChangeEvent<{
      name?: string;
      value?: unknown;
    }>,
  ) => {
    props.setDecisionCosts(event.target.value);
  };
  const handleChangeInvoiceNumber = (
    event: React.ChangeEvent<{
      name?: string;
      value?: unknown;
    }>,
  ) => {
    props.setInvoiceNumberAdditionnelFees(event.target.value);
  };

  const handleChangeInvoiceDate = (date: Date | null) => {
    const theDate = getDateIgnoreTimezone(date);
    const invoiceDate = moment(theDate as Date).format(DATE_FORMAT);
    props.setInvoiceDateAdditionnelFees(invoiceDate);
  };

  const handleChangeInvoiceReceptionDate = (date: Date | null) => {
    const theDate = getDateIgnoreTimezone(date);
    const invoiceDate = moment(theDate as Date).format(DATE_FORMAT);
    props.setInvoiceReceptionDateAdditionnelFees &&
      props.setInvoiceReceptionDateAdditionnelFees(invoiceDate);
  };

  const setDocument = (docSelected: CorporealDocument) => {
    props.handleChangeCosts({
      ...props.cost,
      document: { ...props.cost.document, ...docSelected },
    });
    props.setInvoiceAdditionnelFeesDocument({
      ...docSelected,
      type: DOCUMENT_TYPES.INVOICE_DOCUMENT,
    });
    props.resetUploadedDocument();
  };
  return (
    <Dialog
      onClose={handleClose}
      aria-labelledby="simple-dialog-title"
      open={props.open}
    >
      <DialogTitle id="simple-dialog-title">
        {translate({ ...messages.costsDialogTitle }, props)}
      </DialogTitle>
      <DialogContent>
        <StyledDiv>
          <Typography className="success-title">
            {'vous voulez ajouter des frais supplementaires ?'}
          </Typography>
          <FormControl
            style={{
              display: 'flex',
              justifyContent: 'space-around',
              margin: 15,
            }}
          >
            <RadioGroup
              row
              onChange={handleChangeDecisionCosts}
              value={props.decisionCosts}
            >
              <FormControlLabel
                control={<Radio color="primary" value={CHOICE.YES} />}
                label={translate(
                  messages.preopeningManagerConfirmationDialogConfirm,
                  props,
                )}
              />
              <FormControlLabel
                control={<Radio color="primary" value={CHOICE.NO} />}
                label={translate(
                  messages.preopeningManagerConfirmationDialogCancel,
                  props,
                )}
              />
            </RadioGroup>
          </FormControl>
          {props.decisionCosts === CHOICE.YES && (
            <>
              <TextField
                label={translate({ ...messages.feeNoteFrais }, props)}
                type="number"
                name={'costs'}
                className="input"
                value={get(props.cost, 'costs') || ''}
                onChange={handleChange('costs')}
                error={false}
                helperText=""
              />
              {featureService.hasFeature(FEATURES.LIMIT_INVOICE_DATE) && (
                <>
                  <Typography className="subtitle">
                    {translate({ ...messages.invoiceTitle }, props)}
                  </Typography>
                  <TextField
                    label={translate(messages.invoiceNumberField, props)}
                    name={'INVOICE_NUMBER'}
                    value={props.invoiceNumberAdditionnelFees}
                    fullWidth
                    className="input"
                    onChange={handleChangeInvoiceNumber}
                  />
                  {compareDate(
                    moment().format('YYYY-MM-DD'),
                    moment(props.invoiceDateAdditionnelFees).format(
                      'YYYY-MM-DD',
                    ),
                  ) >= props.limitInvoiceDate &&
                    !isNil(props.invoiceDateAdditionnelFees) && (
                      <WarningCard
                        message={translate(
                          messages.warningInvoiceDateManager,
                          props,
                          {
                            limitDaysManager: props.limitInvoiceDate,
                          },
                        )}
                      />
                    )}
                  <MuiPickersUtilsProvider
                    utils={DateFnsUtils}
                    locale={frLocale}
                  >
                    <KeyboardDatePicker
                      autoOk
                      variant="inline"
                      format={DATE_PICKET_FORMAT}
                      id="invoice-date"
                      fullWidth
                      className="input"
                      onChange={handleChangeInvoiceDate}
                      value={dateStringToLocalDate(
                        props.invoiceDateAdditionnelFees,
                      )}
                      label={translate(messages.invoiceDateField, props)}
                    />
                  </MuiPickersUtilsProvider>
                  <MuiPickersUtilsProvider
                    utils={DateFnsUtils}
                    locale={frLocale}
                  >
                    <KeyboardDatePicker
                      autoOk
                      className="input"
                      variant="inline"
                      format={DATE_PICKET_FORMAT}
                      id="invoice-date"
                      fullWidth
                      onChange={handleChangeInvoiceReceptionDate}
                      value={dateStringToLocalDate(
                        props.invoiceReceptionDateAdditionnelFees,
                      )}
                      label={translate(
                        messages.invoiceReceptionDateField,
                        props,
                      )}
                    />
                  </MuiPickersUtilsProvider>
                </>
              )}
              <FormControl className="input">
                <InputLabel id="fee-note-doc-type-label">
                  {translate({ ...get(messages, 'documentType') }, props)}
                </InputLabel>
                <Select
                  labelId="fee-note-doc-type-select"
                  onChange={handleChange(DOCUMENT.TYPE)}
                  name={DOCUMENT.TYPE}
                  value={get(props.cost, 'document.type', '')}
                >
                  {DOC_TYPES.map((type: any, index: number) => (
                    <MenuItem key={index} value={type}>
                      {translate({ ...get(DOC_MESSAGES, type) }, props)}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <UploadDocumentBloc
                index={0}
                document={props.cost.document}
                setDocument={setDocument}
                resetUploadedDocument={props.resetUploadedDocument}
                uploadDocument={props.uploadDocument}
                uploadedDocument={props.uploadedDocument}
                docType={get(props.cost, 'document.type', '')}
                setDocumentId={props.setDocumentId}
                docId={'90000'}
              />

              {get(props.cost, 'document.type', '') === 'EXCEPTIONAL' && (
                <TextField
                  label={translate({ ...messages.comment }, props)}
                  className="input"
                  style={{ marginTop: '20px' }}
                  name={FEE_NOTE.COMMENT}
                  value={get(props.cost, [FEE_NOTE.COMMENT]) || ''}
                  multiline
                  rows={2}
                  onChange={handleChange(FEE_NOTE.COMMENT)}
                  disabled={false}
                  error={false}
                  helperText=""
                ></TextField>
              )}
            </>
          )}
        </StyledDiv>
      </DialogContent>
      <StyledDialogActions>
        <SecondaryButton
          onClick={handleClose}
          disableElevation
          title={translate(
            { ...messages.preOpeningManagerProviderDialogCancelButton },
            props,
          )}
        />
        <PrimaryButton
          className="primary-button"
          onClick={() => props.ConfirmAction()}
          disableElevation
          disabled={
            props.decisionCosts === CHOICE.YES &&
            (isNil(get(props.cost, 'document.url', null)) ||
              isNil(get(props.cost, [FEE_NOTE.COSTS], null)) ||
              isNil(get(props.cost, 'document.type', null)))
          }
          title={translate(
            { ...messages.preOpeningManagerProviderDialogValidationButton },
            props,
          )}
        />
      </StyledDialogActions>
    </Dialog>
  );
};

CostsDialog.defaultProps = {
  open: false,
};

export default injectIntl(CostsDialog);
